import { Icon } from '@iconify/react/dist/iconify.js';
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function Pagination({ page=0, pages, onPageChange }) {
    const currentPage = page
    const maxVisiblePages = 10;

    const renderPageNumbers = () => {
        const pageNumbers = [];
        if (pages <= maxVisiblePages) {
            for (let i = 1; i <= pages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (currentPage <= Math.ceil(maxVisiblePages / 2)) {
                for (let i = 1; i <= maxVisiblePages - 1; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
                pageNumbers.push(pages);
            } else if (currentPage >= pages - Math.floor(maxVisiblePages / 2)) {
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = pages - (maxVisiblePages - 2); i <= pages; i++) {
                    pageNumbers.push(i);
                }
            } else {
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
                pageNumbers.push(pages);
            }
        }

        return pageNumbers.map((pageNumber, index) => (
            <a
                className={`d-flex align-items-center bg-${
                    pageNumber === currentPage ? 'primary-600' : 'primary-50'
                } border-0 h-32-px justify-content-center text-${
                    pageNumber === currentPage ? 'white' : 'secondary-light'
                } w-32-px fw-medium me-8 page-link px-10 py-10 radius-4`}
                onClick={() => typeof pageNumber === 'number' && onPageChange(pageNumber)}
            >
                <li key={index} className="page-item">
                    {pageNumber}
                </li>
            </a>
        ));
    };

    // useEffect(() => {
    //     if(currentPage !== page){
    //         onPageChange(page)
    //     }
    // }, [page])

    return (
        <ul className="d-flex flex-wrap align-items-center justify-content-center gap-2 pagination">
            <li className="page-item">
                <Link
                    className="d-flex align-items-center bg-base border-0 h-32-px justify-content-center text-secondary-light w-32-px fw-medium me-8 page-link px-10 py-10 radius-4"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    <Icon icon="ep:d-arrow-left" className="text-xl" />
                </Link>
            </li>
            {renderPageNumbers()}
            <li className="page-item">
                <Link
                    className="d-flex align-items-center bg-base border-0 h-32-px justify-content-center text-secondary-light w-32-px fw-medium me-8 page-link px-10 py-10 radius-4"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === pages}
                >
                    <Icon icon="ep:d-arrow-right" className="text-xl" />
                </Link>
            </li>
        </ul>
    );
}
